import {Brick, registerBrick, Service} from 'olympe';
import {SHARED_MEMORY_TOPICS} from '../../../services/service_api/CreateAllRASharedMemory.brick';

/**
 * This brick is responsible for fetching session IDs associated with 'candex_session_id'
 * from the shared memory service.
 */
export default class GetFromCandexTimeoutMap extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     * @param {function(string)} setSessionId
     */
    update($, [userId], [forwardEvent, setSessionId]) {
        Service.get('allRaSharedMemory', {topic: SHARED_MEMORY_TOPICS.CANDEX_SESSION_ID, userId: userId})
            .then((data) => {
                setSessionId(data.sessionId);
                forwardEvent();
            });
    }
}

registerBrick('0197bfb073d005dbfcfb', GetFromCandexTimeoutMap);
